import p from "./extends.mjs";
import q from "./objectWithoutPropertiesLoose.mjs";
import * as f from "react";
import n from "./index180.mjs";
import z from "./useTheme.mjs";
import { reflow as D, getTransitionProps as g } from "./utils10.mjs";
import { jsx as V } from "react/jsx-runtime";
import W from "./useForkRef.mjs";
import $ from "./elementAcceptingRef.mjs";
import B from "./Transition.mjs";
const G = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], H = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, h = /* @__PURE__ */ f.forwardRef(function(E, T) {
  const i = z(), b = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: m,
    appear: R = !0,
    children: a,
    easing: l,
    in: u,
    onEnter: x,
    onEntered: L,
    onEntering: P,
    onExit: y,
    onExited: v,
    onExiting: w,
    style: d,
    timeout: c = b,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: F = B
  } = E, _ = q(E, G), s = f.useRef(null), j = W(s, a.ref, T), o = (e) => (t) => {
    if (e) {
      const r = s.current;
      t === void 0 ? e(r) : e(r, t);
    }
  }, C = o(P), O = o((e, t) => {
    D(e);
    const r = g({
      style: d,
      timeout: c,
      easing: l
    }, {
      mode: "enter"
    });
    e.style.webkitTransition = i.transitions.create("opacity", r), e.style.transition = i.transitions.create("opacity", r), x && x(e, t);
  }), k = o(L), A = o(w), N = o((e) => {
    const t = g({
      style: d,
      timeout: c,
      easing: l
    }, {
      mode: "exit"
    });
    e.style.webkitTransition = i.transitions.create("opacity", t), e.style.transition = i.transitions.create("opacity", t), y && y(e);
  }), S = o(v);
  return /* @__PURE__ */ V(F, p({
    appear: R,
    in: u,
    nodeRef: s,
    onEnter: O,
    onEntered: k,
    onEntering: C,
    onExit: N,
    onExited: S,
    onExiting: A,
    addEndListener: (e) => {
      m && m(s.current, e);
    },
    timeout: c
  }, _, {
    children: (e, t) => /* @__PURE__ */ f.cloneElement(a, p({
      style: p({
        opacity: 0,
        visibility: e === "exited" && !u ? "hidden" : void 0
      }, H[e], d, a.props.style),
      ref: j
    }, t))
  }));
});
process.env.NODE_ENV !== "production" && (h.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: n.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: n.bool,
  /**
   * A single child content element.
   */
  children: $.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: n.oneOfType([n.shape({
    enter: n.string,
    exit: n.string
  }), n.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: n.bool,
  /**
   * @ignore
   */
  onEnter: n.func,
  /**
   * @ignore
   */
  onEntered: n.func,
  /**
   * @ignore
   */
  onEntering: n.func,
  /**
   * @ignore
   */
  onExit: n.func,
  /**
   * @ignore
   */
  onExited: n.func,
  /**
   * @ignore
   */
  onExiting: n.func,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: n.oneOfType([n.number, n.shape({
    appear: n.number,
    enter: n.number,
    exit: n.number
  })])
});
const tn = h;
export {
  tn as default
};
//# sourceMappingURL=Fade.mjs.map
